<template>
  <div v-if="playlistFormat" class="pro-venue-spotify">
    <iframe
      style="border-radius: 12px"
      :src="playlistFormat"
      width="75%"
      height="120"
      frameBorder="0"
      allowfullscreen=""
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      loading="lazy"
    ></iframe>
  </div>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  playlist: {
    type: String,
    default: ""
  }
});

const playlistFormat = computed(() => {
  if (props.playlist) {
    const regex = /\bembed\b/;
    const hasEmbed = regex.test(props.playlist);

    if (hasEmbed) {
      return props.playlist;
    } else {
      return props.playlist.replace(
        "https://open.spotify.com/playlist/",
        "https://open.spotify.com/embed/playlist/"
      );
    }
  }
  return undefined;
});
</script>

<style lang="scss" scoped></style>
